import { render, staticRenderFns } from "./tvInddex.vue?vue&type=template&id=37b9c1a0&scoped=true"
import script from "./tvInddex.vue?vue&type=script&lang=ts"
export * from "./tvInddex.vue?vue&type=script&lang=ts"
import style0 from "./tvInddex.vue?vue&type=style&index=0&id=37b9c1a0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37b9c1a0",
  null
  
)

export default component.exports